import { AxiosInstance } from "axios";
import { Entry } from "../models/entry";

const ENTRIES_API_PREFIX = "/entries/entries";

export const getEntriesByDrawId = async (
	http: AxiosInstance,
	drawId: number
): Promise<Entry[]> => {
	const response = await http.get<Entry[]>(`${ENTRIES_API_PREFIX}/${drawId}`);
	return response.data;
};
